import { render, staticRenderFns } from "./UplodeMultiple.vue?vue&type=template&id=3fcee89a&scoped=true"
import script from "./UplodeMultiple.vue?vue&type=script&lang=js"
export * from "./UplodeMultiple.vue?vue&type=script&lang=js"
import style0 from "./UplodeMultiple.vue?vue&type=style&index=0&id=3fcee89a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fcee89a",
  null
  
)

export default component.exports